'use client'
import Spinner from "@/components/Spinner";

export default function RootLoading() {
    return (
        <Spinner loading={true} timer={5000}><></></Spinner>
    );
}